import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import ru from './locales/ru.json'
import pt from './locales/pt.json'
import nb from './locales/nb.json'
import da from './locales/da.json'
import sv from './locales/sv.json'
import fi from './locales/fi.json'
import pl from './locales/pl.json'
import bg from './locales/bg.json'
import bs from './locales/bs.json'
import cs from './locales/cs.json'
import hr from './locales/hr.json'
import hu from './locales/hu.json'
import sk from './locales/sk.json'
import sl from './locales/sl.json'
import sr from './locales/sr.json'
import cy from './locales/cy.json'
import nl from './locales/nl.json'

Vue.use(VueI18n)

const locale = window.localStorage.getItem('locale') || 'en'

const messages = {
  en,
  fr,
  de,
  ru,
  pt,
  nb,
  da,
  sv,
  fi,
  pl,
  bg,
  bs,
  cs,
  hr,
  hu,
  sk,
  sl,
  sr,
  cy,
  nl
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: {'default': 'en'},
  messages,
  silentTranslationWarn: true
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js